import React, { useEffect, useState } from "react";
import {
  AutoComplete,
  InputNumber,
  Button,
  Table,
  Card,
  Space,
  Form,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { getAccountBySeachApi } from "../../apiservice/setting";
import "./addExpenses.css";

const { Summary } = Table;

const AddExpensesSection = ({ onFooterChange, servicePayCart, conversionRate }) => {
  const [form] = Form.useForm();
  const [accounts, setAccounts] = useState([]);
  const [data, setData] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [accountSearch, setAccountSearch] = useState("")

  useEffect(() => {
    fetchAccounts();
  }, []);

  useEffect(() => {
    if (servicePayCart && Array.isArray(servicePayCart)) {
      const formattedData = servicePayCart.map((item, idx) => ({
        key: item.key || `expense_${idx}`,
        type: item.type || item.to_acc_name || item.from_acc_name,
        tran_amount: parseFloat(item.tran_amount) || 0,
        date: item.date,
        to_acc_id: item.to_acc_id || item.from_acc_id,
        acc_type_id: item.acc_type_id,
      }));
      setData(formattedData);
    }
  }, [servicePayCart]);




  const fetchAccounts = async () => {
    try {
      const res = await getAccountBySeachApi({ multiType: ["direct_income"] });
      const filtered = res.data.filter(
        (item) => !item.display_text?.includes("Discount on purchase")
      );
      setAccounts(filtered || []);
    } catch (err) {
      setAccounts([]);
    }
  };

  const onFinish = (values) => {
    const selectedAcc =
      accounts.find((a) => a.acc_name === values.account) || {};

    const newEntry = {
      to_acc_id: selectedAcc?.acc_id ?? 0,
      to_acc_name: selectedAcc?.acc_name ?? values.account,
      acc_type_id: selectedAcc?.acc_type_id,
      tran_amount: Number(values.amount),
    };

    const newData = [...data];
    if (editingIndex !== null) {
      newData[editingIndex] = newEntry;
      setEditingIndex(null);
    } else {
      newData.push(newEntry);
    }

    setData(newData);

    // 🔑 emit clean data upward
    onFooterChange(newData, "payServiceCart");

    form.resetFields();
  };

  const edit = (record, index) => {
    form.setFieldsValue({
      account: record.type,
      amount: record.tran_amount,
    });
    setEditingIndex(index);
  };

  const remove = (index) => {
    const newData = data.filter((_, i) => i !== index);
    setData(newData);
    onFooterChange(newData, "payServiceCart");
  };

  const columns = [
    { title: "Expense Account", dataIndex: "type", key: "to_acc_name" },
    {
      title: "Amount",
      dataIndex: "tran_amount",
      key: "tran_amount",
      align: "right",
      render: (val) => {
        const amount = Number(val);
        const finalAmount = conversionRate ? amount * conversionRate : amount;
        return amount ? finalAmount?.toFixed(2) : "0.00";
      },
      //  Number(val).toFixed(2),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record, index) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => edit(record, index)}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            size="small"
            onClick={() => remove(index)}
          />
        </Space>
      ),
    },
  ];

  return (
    <Card title="Additional Expenses" style={{ marginTop: 5, marginBottom: 5 }}>
      <Form
        form={form}
        layout="inline"
        onFinish={onFinish}
        style={{ marginBottom: 10 }}
        className="add-expenses-inline-form"
      >
        <Form.Item
          name="account"
          style={{ flex: 2 }}
          rules={[{ required: true, message: "Please select an account!" }]}
        >
          <AutoComplete
            placeholder="Service Account"
            value={accountSearch}
            options={accounts.map((acc) => ({
              value: acc.acc_name,
              label: acc.acc_name,
              obj: acc,
            }))}
          />
        </Form.Item>

        <Form.Item
          name="amount"
          style={{ flex: 1 }}
          rules={[{ required: true, message: "Please enter amount!" }]}
        >
          <InputNumber
            min={0}
            style={{ width: "100%" }}
            placeholder="Amount"
            formatter={(value) => {
              parseFloat(
                conversionRate ? value * conversionRate : value
              )?.toFixed(2);
            }}
            onChange={(value) => {
              // Apply conversion instantly
              const amount = conversionRate ? value / conversionRate : value;
              form.setFieldsValue({ amount: Number(amount).toFixed(2) });
            }}
            onWheel={(e) => e.target.blur()}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            {editingIndex !== null ? "Update" : "Add"}
          </Button>
        </Form.Item>
      </Form>

      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey={(r, i) => i}
        scroll={{ x: "max-content" }}
        summary={() => (
          <Summary.Row>
            <Summary.Cell index={0}>
              <strong>Total:</strong>
            </Summary.Cell>
            <Summary.Cell index={1} align="right">
              <strong>
                {(conversionRate
                  ? data.reduce(
                    (sum, r) =>
                      sum + Number(r.tran_amount || 0) * conversionRate,
                    0
                  )
                  : data.reduce((sum, r) => sum + Number(r.tran_amount || 0), 0)
                ).toFixed(2)}
              </strong>
            </Summary.Cell>
          </Summary.Row>
        )}
      />
    </Card>
  );
};

export default AddExpensesSection;
